<template>
  <div>
    <custom-callout
      border-color="orange"
      class="mb-4 custom-callout-invoice"
      :has-toggle="false"
    >
      <div class="row py-2">
        <div class="col-md-12">
          <div class="d-flex">
            <span
              class="dot d-flex justify-content-center align-items-center py-2 px-1 mt-2"
            >
              <i class="orange-icon orange-icon-badge-align fas fa-donate" />
            </span>
            <span
              class="d-flex justify-content-center align-items-center py-1 px-1 mt-2 ml-2 font-weight-bold"
            >
              Ajustar Solicitud
            </span>
          </div>
        </div>
      </div>
      <validation-observer
        ref="adjustmentRef"
        class="pr-4"
        novalidate
        tag="form"
      >
        <div class="row mt-4">
          <div class="col-md-4">
            <div class="font-14 color-gray-6 mb-1">
              ¿Qué tipo de ajuste desea realizar?
            </div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-radio
                id="creation-adjustment-adjustmentType"
                v-model="model.adjustmentType"
                class="mt-3 radio-custom font-14"
                custom-error-msg="El tipo de ajuste es requerido."
                :error="Boolean(errors[0])"
                is-inline
                name="adjustmentType"
                :options="adjustmentOptions"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="font-14 color-gray-6 mb-1">
              Cantidad a ajustar:
            </div>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                required: 'La cantidad es requerida.',
                greaterThanZeroCustomMsg: 'La cantidad deber ser mayor a 0.',
              }"
              :rules="'required|greaterThanZero'"
            >
              <div class="input-group mb-3">
                <custom-input
                  id="adjustment-amount"
                  v-model="model.amount"
                  class="w-70"
                  :class="getAmountClass"
                  custom-error-msg="La cantidad deber ser mayor a 0."
                  :error="errors[0]"
                  mask-type="Money"
                  :min="0"
                  placeholder="0.00"
                  :prepend-icon="getAmountIcon"
                  type="number"
                />
              </div>
            </validation-provider>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-sm-12">
            <div class="color-gray-6 font-14 mb-2">
              Razón:
            </div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="adjustment-reason"
                v-model="model.reason"
                custom-error-msg="La razón es requerida."
                :error="errors[0]"
                maxlength="500"
              />
            </validation-provider>
          </div>
          <div class="col-md-8 col-sm-12">
            <div class="color-gray-6 font-14 mb-2">
              Comentario:
            </div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="adjustment-comment"
                v-model="model.comments"
                custom-error-msg="El comentario es requerido."
                :error="errors[0]"
                maxlength="3000"
              />
            </validation-provider>
          </div>
        </div>
        <div
          class="row ml-2 mt-3 mb-3 d-flex align-items-end justify-content-end"
        >
          <div class="col-md-6 text-right mt-4">
            <action-button
              i="fas fa-times-circle"
              variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
              @click="onCancelAdjustment"
            >
              Cancelar
            </action-button>
            <action-button
              i="fas fa-save"
              variant="success pl-4 pr-4"
              @click="onSaveAdjustment"
            >
              Guardar
            </action-button>
          </div>
        </div>
      </validation-observer>
    </custom-callout>
  </div>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomRadio from 'custom-radio';
import CustomInput from 'CustomInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import alertMixin from '@/mixins/alert.mixin';

export default {
  name: 'CreateAdjustment',
  components: {
    CustomCallout,
    ActionButton,
    CustomRadio,
    CustomInput,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [alertMixin],
  data() {
    return {
      model: {
        reason: null,
        comments: null,
        amount: null,
        adjustmentType: null,
      },
      adjustmentOptions: [
        {
          id: 1,
          name: 'rb-adjustmentType',
          value: 'positive',
          label: 'Positivo',
          check: true,
          invalid: false,
          disabled: false,
        },
        {
          id: 2,
          name: 'rb-adjustmentType',
          value: 'negative',
          label: 'Negativo',
          check: false,
          invalid: false,
          disabled: false,
        },
      ],
    };
  },
  computed: {
    getAmountIcon() {
      return this.model.adjustmentType &&
        this.model.adjustmentType.value == 'negative'
        ? 'fas fa-minus text-white'
        : 'fas fa-plus text-white';
    },
    getAmountClass() {
      return this.model.adjustmentType &&
        this.model.adjustmentType.value == 'negative'
        ? 'danger'
        : 'success';
    },
  },
  methods: {
    onCancelAdjustment() {
      this.$emit('on-close');
    },
    async onSaveAdjustment() {
      const isValid = await this.$refs.adjustmentRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información requerida.',
          'error'
        );
        return;
      }

      let payload = {
        reason: this.model.reason,
        comments: this.model.comments,
        amount: parseFloat(
          this.model.adjustmentType.value === 'negative'
            ? -Math.abs(this.model.amount)
            : Math.abs(this.model.amount)
        ),
      };

      this.$emit('on-save', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';
.dot {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ff7058 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
  padding: 13px !important;
  border: 3px solid #fff;
}
.orange-icon {
  color: #ffffff;
  font-size: 12pt;
  padding-right: 4px;
  line-height: 25px;
  margin-left: 4px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

::v-deep .input-group-text {
  background-color: map-get($colors, 'green');
  border-color: map-get($colors, 'green');
}

.danger ::v-deep .input-group-text {
  background-color: map-get($colors, 'red');
  border-color: map-get($colors, 'red');
}

.radio-custom ::v-deep .col-12 {
  padding-left: 0;

  .custom-control-inline {
    margin-right: 3rem !important;
  }

  .custom-control-label {
    padding-top: 2px;
  }
}
</style>
